import React from "react";

import { useLocation } from 'react-router-dom';

import VideosHomeView from './view';
import InnerSidebarNavigation from '@components/InnerSidebarNavigation'
import GoBackArrow from '@assets/sidebarNavigation/goBackArrow.png';

function VideosHome() {
    const location = useLocation();
    
    //Failsafe if no data received from navigation
    let navigationData = [{
        "title": "Back to Content",
        "route": "/content",
        "icon": GoBackArrow
    }];
    if (location.state && location.state.finalNavigationData) {
        navigationData = location.state.finalNavigationData;
    }
    
    return (
        <>
            <InnerSidebarNavigation
                navigationData={navigationData} />
            <VideosHomeView />
        </>
    )
}

export default VideosHome;